import Fresco81 from "./fresco8.webp";

const Fresco8 = [Fresco81];

export default Fresco8;
